import { create } from "zustand";

const usetranslatedTextStore = create((setTranslatedText)=>({
    translatedTextArray:[],
    allLanguage:{},
    translatedText:null,
    targetLanguageCode:'',
    textId:'',
    responseTranslatedText:[],
    setTranslatedText : setTranslatedText
}))


export default usetranslatedTextStore;